export default __webpack_public_path__ + "static/media/collection-img-sample3@3x.d8661a39.png";